import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

export interface IAlert {
    title: string;
    indexScenarioError: number[];
}

const initialState: IReduxState<IAlert> = {
    status: EReduxState.initialState,
};

export const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        cleanAlert: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setAlert: (state, action: PayloadAction<IAlert>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanAlert, setAlert } = alertSlice.actions;

export const selectAlert = (state: RootState) => state.alert;

export default alertSlice.reducer;
